import type { MachineDetail } from "../../types/machine-detail";
import type { MachineEntity, RouterMachinesResponse } from "../../types/machine";
import type { CompanyMachineRepository } from "../../repositories/company/company-machine-repository";
import { AppError } from "../../../shared/utils/error-handler";

export class CompanyMachineUseCase {
  constructor(private companyMachineRepository: CompanyMachineRepository) {}

  async getMachineDetails(companyId: number): Promise<MachineDetail[]> {
    try {
      return await this.companyMachineRepository.getMachineDetails(companyId);
    } catch (error) {
      throw new AppError(
        String(error) || "장비 정보를 불러오지 못했습니다.",
        "MACHINE_DETAILS_GET_FAILED",
        error,
      );
    }
  }

  async getMachineDetailsByRouter(companyId: number): Promise<RouterMachinesResponse[]> {
    try {
      return await this.companyMachineRepository.getMachineDetailsByRouter(companyId);
    } catch (error) {
      throw new AppError(
        String(error) || "라우터별 장비 정보를 불러오지 못했습니다.",
        "MACHINE_DETAILS_GET_FAILED",
        error,
      );
    }
  }
}